import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const SoundMutedIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 14"
  >
    <path d="m3.856 2.917-.829.593H.818c-.49 0-.818.35-.818.877V9.65c0 .526.327.877.818.877h2.21l4.663 3.334c.573.351 1.309 0 1.309-.702v-5.1l1.445 1.446a.75.75 0 0 0 1.06 1.06l1.062 1.061a.75.75 0 0 0 1.059 1.06l.844.843a.75.75 0 1 0 1.06-1.06l-12-12a.75.75 0 0 0-1.06 1.06zM11.446 6.385l1.479 1.48a5 5 0 0 0-1.39-4.4.75.75 0 0 0-1.06 1.06 3.5 3.5 0 0 1 .97 1.86M14.154 9.093l1.156 1.157q.042-.094.081-.188a8 8 0 0 0-1.734-8.719.75.75 0 0 0-1.06 1.06 6.5 6.5 0 0 1 1.557 6.69M6.26 1.199 9 3.939V.878C9 .176 8.264-.263 7.69.176z" />
  </svg>
);
SoundMutedIcon.displayName = 'SoundMutedIcon';
export default SoundMutedIcon;
